export default `
clip-path: polygon(20% 0%, 100% 0%, 80% 100%, 0% 100%);
`
